import { ChangeDetectionStrategy, Component, EventEmitter, Input, isDevMode, OnInit, Output, ViewChild, Renderer2, OnDestroy } from '@angular/core'
import { FormControl, FormGroup, FormGroupDirective } from '@angular/forms'

import { Authenticate } from '../../models/auth'
import { Observable } from 'rxjs';
import { select, Store } from '@ngrx/store';

import * as fromBase from '../../../base/reducers';
import * as status from '../../../base/actions/status.actions';

@Component({
  selector: 'app-login-page',
  templateUrl: './template.html',
  styleUrls: ['./styles.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginPageComponent implements OnInit, OnDestroy {
  @ViewChild(FormGroupDirective) formGroupDir: FormGroupDirective
  @Input() loggingIn: boolean
  @Input() error: any

  @Output() login = new EventEmitter<Authenticate>()

  loginForm: FormGroup = new FormGroup({
    username: new FormControl(''),
    password: new FormControl('')
  })

  fullWidthView$: Observable<boolean>

  constructor(
    private store: Store<any>,
    private renderer: Renderer2) {
    this.fullWidthView$ = store
      .pipe(
        select(fromBase.isFullWidthViewEnabled)
      )

      // remove header
      this.store.dispatch(new status.SetHeader(false));
  }

  ngOnInit() {
    if (this.devMode) {
      this.loginForm.addControl('tenant', new FormControl(''))
    }
    // add login class to body for background image
    this.renderer.addClass(document.body, 'login');
  }

  ngOnDestroy() {
    // remove login class
    this.renderer.removeClass(document.body, 'login');
  }

  get devMode(): boolean {
    return isDevMode()
  }

  submit() {
    if (this.loginForm.valid)
      this.login.emit(this.loginForm.value)
  }
}
